import React from 'react';
import { useSelector } from 'react-redux';

function SubmissionErrorNotice({ message }) {
    const contact = useSelector(state => state.appUI.realEstateAgentTexts.personal.homePage.text);
    if (!message) return null;
    return (
        <div className="alert alert-danger" role="alert">
            <p>{message}</p>
            <p className="mb-0">
                Můžete mě kontaktovat přímo: <a href={contact.hrefMobile}>{contact.contactMobile}</a>
                {' · '}<a href={contact.hrefEmail}>{contact.contactEmail}</a>
            </p>
        </div>
    );
}

export default SubmissionErrorNotice;
